/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type AttachAuthClientToMcpServerRequestBody = {
  /**
   * The auth client id.
   */
  id: string;
  /**
   * The MCP server id.
   */
  mcpServerId: string;
};

/** @internal */
export type AttachAuthClientToMcpServerRequestBody$Outbound = {
  id: string;
  mcp_server_id: string;
};

/** @internal */
export const AttachAuthClientToMcpServerRequestBody$outboundSchema:
  z.ZodMiniType<
    AttachAuthClientToMcpServerRequestBody$Outbound,
    AttachAuthClientToMcpServerRequestBody
  > = z.pipe(
    z.object({
      id: z.string(),
      mcpServerId: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        mcpServerId: "mcp_server_id",
      });
    }),
  );

export function attachAuthClientToMcpServerRequestBodyToJSON(
  attachAuthClientToMcpServerRequestBody:
    AttachAuthClientToMcpServerRequestBody,
): string {
  return JSON.stringify(
    AttachAuthClientToMcpServerRequestBody$outboundSchema.parse(
      attachAuthClientToMcpServerRequestBody,
    ),
  );
}
